import React from "react";
import { Modal, Button } from "react-bootstrap";
function CustomModal({ show, header, children, handleClose, btns, size, className }) {
  return (
    <div>
      <Modal
        show={show}
        backdrop="static"
        centered
        size={size ? size : "lg"}
        onHide={handleClose}
        className={className}
      >
        <Modal.Header closeButton>
          <Modal.Title>{header}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{children}</Modal.Body>
      </Modal>
    </div>
  );
}

export default CustomModal;
